import React, { Component } from "react";
import { Layout, PageHeader,  Col, Row, Tabs, message, Button } from "antd";
import { BarChartOutlined, SnippetsOutlined } from '@ant-design/icons'
import { CardVMIInfo } from "../../Widgets/Cards";
import '../../../Styles/Modules/Customer/customer.css'

//Listados
import Almacenes from './Almacenes'
import ProductosList from './Productos'
import PagosList from './Pagos'
import ComprasList from './ComprasList'
import SolicitudesList from './SolicitudesCompras/SolicitudesList';

//Drawer
import DrawerFiltros from './DrawerFiltros';

import User from "../../../Hooks/Logged";

const { Content } = Layout;
const { TabPane } = Tabs;
const axios = require('axios')
/**
 *
 *
 * @export
 * @class Comprar
 * @extends {Component}
 * @description Vista de Project Manager
 */
class Comprar extends Component {


    constructor(props) {
        super(props)
        this.state = {
            current: 0,
            productos: [],
            list: 5,

            monto_venta: 0,
            facturas_emitidas_monto: 0,
            facturas_cobradas: 0,
            pendiente_facturar_monto: 0,
            cliente: {},
            currentTab: 'productos',

        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
        this.getClienteInfo();
    }


    /**
   * @memberof  
   * @method getCliente
   * @description Obtiene un cliente de la DB
   */
    getClienteInfo = () => {

        axios.get('/vmi/getInfoClienteVMI', {
            params: {}
        })
            .then(({ data }) => {

                if (data.success) {
                    data = data.data;
                    this.setState({
                        cliente: data.cliente,
                        venta_count_mes: data.venta_count_mes,
                        venta_total_mes: data.venta_total_mes,

                        venta_count: data.venta_count,
                        venta_total: data.venta_total,
                    })
                }

            })
            .catch(error => {
                message.error('No se obtuvo la info cliente')
                console.log(error)
            })
    }

    /**
     * @method descargarReporte
     * @description Descarga el reporte csv dependiendo del tab seleccionado, solo descargara informacion del cliente logueado,
     * ya que no se envia el id del cliente en la peticion
     */
    descargarReporte = () => {
        
        const { currentTab } = this.state;
        const  endpoint = currentTab === "productos" ? '/vmi/productos/list-v2' : '/vmi/list'

        let url = new URL(axios.defaults.baseURL + endpoint);
        url.searchParams.set('csv', true)
        url.searchParams.set(this.state.currentTab, true)
        url.searchParams.set('Authorization', sessionStorage.getItem('token'))
        window.open(url, '_blank');

    }

     /**
     * @method renderButtonDescargarCatalogo
     * @description Descarga el catalogo de productos, (solo para usuarios de Balluff)
     * NOTA EN EL FUTURO: HACER MODIFICACION A LA BD Y API PARA QUE SE PUEDA DESCARGAR EL CATALOGO DE OTROS CLIENTES
     */
    renderButtonDescargarCatalogo = () => {
        
        if(this.props?.user?.cliente_id?.razon_social === "BALLUFF MANUFACTURING AGUASCALIENTES") {
            return <a href="/catalogos/Catalogo-Nexus-Balluff-2025.pdf" target="_blank" rel="noreferrer" download>
                <Button
                    type="secondary"
                    icon={<SnippetsOutlined />}
                >
                    Descargar Catalogo
                </Button>
            </a>
        }

        return null;

    }

    /**
     * @method renderTabBarExtraContent
     * @description Muestra el boton para descargar el reporte de ventas
     * si el tab actual es de 'productos' o 'almacenes', se descarga toda la informacion de estos en csv
     * en caso de que sean 'compras' o solicitudes se abre un Drawer para descargar el reporte csv
     */
    renderTabBarExtraContent = () => {
        const { currentTab } = this.state;

        // Configuración de botones por tab
        const tabConfigs = {
            compras: {
                onClick: () => this.setState({
                    visibleDrawerFiltros: true,
                    url: '/vmi/ventas-v2',
                    params: { csv: true, cliente: true }
                })
            },
            solicitudes: {
                onClick: () => this.setState({
                    visibleDrawerFiltros: true,
                    url: '/customer/solicitudes',
                    params: { csv: true }
                })
            },
            productos: {
                onClick: this.descargarReporte
            },
            almacenes: {
                onClick: this.descargarReporte
            }
        };

        if (tabConfigs[currentTab]) {
            return (
                <Button
                    onClick={tabConfigs[currentTab].onClick || (() => {message.error('Función no implementada')})}
                    type="primary"
                    className="btn-primary"
                    icon={<BarChartOutlined />}
                >
                    Descargar Reporte
                </Button>
            );
        }

        return null;
    }


    render() {

        return (
            <>
                <PageHeader
                    className="site-page-header custom-page-header"
                    title={<Row className=" width-100 " justify="space-between" align="middle">
                        <Col span={22}>
                            <span className="ant-page-header-heading-title" >
                                Vendor-Managed Inventory
                            </span>
                        </Col>
                    </Row>
                    }
                    extra={ this.renderButtonDescargarCatalogo()}
                />
                <Content className="content-bg pd-1" style={{minHeight: '79vh'}}>

                    <Row gutter={[8, 8]}>
                        <Col span={24} className="mb-1">
                            <CardVMIInfo
                                venta_count={this.state.venta_count}
                                venta_total={this.state.venta_total}
                                responsable={this.state.responsable}
                                dias_credito={this.state.cliente?.dias_credito}
                                customer={true}
                            />
                        </Col>

                        <Col span={24}>
                            <Tabs 
                                defaultActiveKey="productos" 
                                destroyInactiveTabPane={true} 
                                className="tabs-inventario"
                                tabBarExtraContent={this.renderTabBarExtraContent()}
                                onChange={(key) => {
                                    this.setState({ currentTab: key });
                                }}
                            >
                                <TabPane tab="Productos" key="productos">
                                    <ProductosList search={this.props.search} />
                                </TabPane>
                                <TabPane tab="Almacenes" key="almacenes">
                                    <Almacenes search={this.props.search} />
                                </TabPane>
                                <TabPane tab="Pagos" key="pagos">
                                    <PagosList search={this.props.search} />
                                </TabPane>
                                <TabPane tab="Compras" key="compras">
                                    <ComprasList search={this.props.search} />
                                </TabPane>
                                { this.props.user?.cliente_id?.centros_costos_habilitados ? <TabPane tab="Solicitudes de Ordenes" key="solicitudes">
                                    <SolicitudesList search={this.props.search} />
                                </TabPane> : null }
                            </Tabs>
                        </Col>
                    </Row>
                </Content>
                <DrawerFiltros
                    visible={this.state.visibleDrawerFiltros}
                    onClose={()=>this.setState({ visibleDrawerFiltros: false, url: '', params: {} })}
                    url={this.state.url}
                    params={this.state.params}
                />
            </>
        )
    }
}


export default function ComprarWrapper(props) {
    const user = React.useContext(User);
    return (
        <Comprar {...props} user={user} />
    );
}

